import { Button } from "antd";
import { PlusIcon } from "../icon";
import { useModal } from "@/common/contexts/Modal.context";
import { NewQuoteModal } from "../Modals";

export default function NewQuotesButton() {
  const { openModal } = useModal();
  const createNewQuote = () => {
    openModal(<NewQuoteModal />);
  };
  return (
    <Button
      onClick={createNewQuote}
      type="primary"
      className="h-10 font-inter font-semibold flex items-center justify-center gap-2"
    >
      <PlusIcon />
      New Quote
    </Button>
  );
}
